<script>
  import { onMount } from "svelte";
  import {
    Container,
    Row,
    Col,
    Button,
    Card,
    CardBody,
    CardTitle,
    Modal,
    Input,
  } from "sveltestrap";

  // import { Link } from "svelte-routing";

  //import Charts
  // import StackedColumnChart from "./StackedColumnChart.svelte";

  // Pages Components
  import KlaidCard from "./KlaidCard.svelte";
  import KlaidSummary from "./dataset-summary.svelte";
  import ActivityComp from "./ActivityComp.svelte";
  import Leaderboard from "./Leaderboard.svelte";
  import KlaidMoving from "./KlaidMoving.svelte";

  // import WelcomeComp from "./WelcomeComp.svelte";
  // import MonthlyEarning from "./MonthlyEarning.svelte";
  // import SocialSource from "./SocialSource.svelte";
  // import TopCities from "./TopCities.svelte";
  // import LatestTranaction from "./LatestTranaction.svelte";
  
  //Import Breadcrumb
  // import Breadcrumbs from "../../common/Breadcrumb.svelte";

  let subscribemodal = false;

  const togglesubscribemodal = () => (subscribemodal = !subscribemodal);

  // onMount(() => {
  //   setTimeout(() => {
  //     subscribemodal = true;
  //   }, 2000);
  // });
</script>

<div class="page-content">
  <Container fluid>
    <!-- <Breadcrumbs title="홈" breadcrumbItem="Dashboard" /> -->
    <Row>
      <Col xl="8">
          <KlaidCard />
      </Col>    
      <Col xl="4">
          <KlaidMoving />
      </Col>
    </Row>
    <Row>
      <Col xl="4">
        <ActivityComp />
      </Col>
      <Col xl="8">
        <KlaidSummary />
        <Leaderboard />
      </Col>
    </Row>
    
  </Container>
</div>

<Modal
  isOpen={subscribemodal}
  role="dialog"
  autoFocus={true}
  data-toggle="modal"
  centered
  on:click={togglesubscribemodal}
>
  <div class="modal-content">
    <div class="modal-header border-bottom-0">
      <button
        type="button"
        class="btn-close"
        on:click={togglesubscribemodal}
        data-bs-dismiss="modal"
        aria-label="Close"
      />
    </div>
    <div class="modal-body">
      <div class="text-center mb-4">
        <div class="avatar-md mx-auto mb-4">
          <div class="avatar-title bg-light  rounded-circle text-primary h1">
            <i class="mdi mdi-email-open" />
          </div>
        </div>

        <div class="row justify-content-center">
          <div class="col-xl-10">
            <h4 class="text-primary">Subscribe !</h4>
            <p class="text-muted font-size-14 mb-4">
              Subscribe our newletter and get notification to stay update.
            </p>

            <div class="input-group  rounded bg-light">
              <Input
                type="email"
                class="form-control bg-transparent border-0"
                placeholder="Enter Email address"
              />
              <Button color="primary" type="button" id="button-addon2">
                <i class="bx bxs-paper-plane" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</Modal>